module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House59.0d22b054.jpg";